var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftCardSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8764 7.06845C9.53091 7.06845 9.15327 7.19255 8.8926 7.48666C8.55122 7.87178 8.44419 9.02271 8.45686 9.60353C9.03327 9.61748 10.1353 9.6022 10.5818 9.15825C11.0486 8.69399 11.1763 7.88276 10.6799 7.38907C10.4639 7.17419 10.1754 7.06845 9.8764 7.06845V7.06845Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47666 7.06845C5.82215 7.06845 6.19979 7.19255 6.46046 7.48666C6.80184 7.87178 6.90887 9.02271 6.8962 9.60353C6.31979 9.61748 5.21769 9.6022 4.77128 9.15825C4.30446 8.69399 4.17671 7.88276 4.67312 7.38907C4.88918 7.17419 5.17764 7.06845 5.47666 7.06845V7.06845Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7677 6.29917C12.6443 7.17076 12.7611 8.5445 12.1605 9.60353H24V5.73625C24 4.52245 23.0142 3.53845 21.7982 3.53845H8.44611V5.91143C9.52518 5.30255 10.8887 5.42507 11.7677 6.29917C10.8887 5.42507 12.2671 6.79573 11.7677 6.29917Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21636 13.9292L4.124 12.8439L5.82108 11.142H0V18.2637C0 19.4775 0.985795 20.4615 2.20179 20.4615H6.90482V12.2359L5.21636 13.9292Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52308 11.142L11.1975 12.8298L10.1024 13.9123L8.44611 12.2428V20.4615H21.7982C23.0142 20.4615 24 19.4775 24 18.2637V11.142H9.52308Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19041 9.60353C2.58974 8.54435 2.70672 7.17071 3.58318 6.29917C4.4622 5.42507 5.82569 5.30261 6.90482 5.91143V3.53845H2.20179C0.985795 3.53845 0 4.52245 0 5.73625V9.60353H3.19041Z",
    fill: "#FB607F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardSelected);
export default __webpack_public_path__ + "static/media/gift-card-selected.85a8e5b553e8dfd28382c88e1aae8afd.svg";
export { ForwardRef as ReactComponent };